const API_URL = process.env.NEXT_PUBLIC_API_URL;

const jsonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

let token = null;
export const saveToken = (_token) => token = _token;
export const getToken = () => token;
export const formatToken = (override) => ({ Authorization: override || `${token}` });
export const parseBody = (body) => (body ? JSON.stringify(body) : undefined);
const hit = async (
  { url, method, authentication, overrideBaseUrl, raw },
  body,
  file,
  headerOverride,
) => {
  const rawResponse = await fetch((overrideBaseUrl || API_URL) + url, {
    method,
    body: file ? body : parseBody(body),
    headers: {
      ...(authentication && token && formatToken()),
      ...(body && !file && jsonHeaders),
      ...(file && { "Content-Type": "multipart/form-data" }),
      ...(headerOverride && headerOverride),
    },
  });
  if (raw) {
    return rawResponse.json();
  }
  let parsedResponse;
  try {
    parsedResponse = await rawResponse.json();
  } catch (err) {
    //
  }
  if (rawResponse.status < 200 || rawResponse.status >= 300) {
    if (parsedResponse) return parsedResponse;
    return { error: true };
  }
  if (rawResponse.status === 204) return {};
  return parsedResponse;
};

export default hit;
